<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container fluid v-bind:class="[{ busy: busy }, 'opacity-transition']">
        <pb-spinner v-if="busy"/>
        <b-table responsive striped hover small :items="customerCategories"
                 :fields="['id', 'name', 'articleCollectionMeta', { key: 'actions', class: 'table-action-column' }]">
            <template v-slot:cell(articleCollectionMeta)="row">
                <v-select
                        :disabled="busy"
                        :searchable="true"
                        @input="update($event, row.item)"
                        label="name"
                        :reduce="collection => collection.id"
                        :value="row.item.articleCollectionMeta ? row.item.articleCollectionMeta.dmixUuid : null"
                        :options="dmixCollections">
                </v-select>
            </template>
            <template v-slot:cell(actions)="row">
                <b-button :disabled="!(row.item.articleCollectionMeta && row.item.articleCollectionMeta.dmixUuid)"
                          variant="link" title="Sync" @click="sync(row.item.id)">
                    <i class="fal fa-sync"></i></b-button>
            </template>
        </b-table>
        <b-modal
                size="xl"
                id="syncLog"
                ref="syncLog"
                ok-only
                title="Sync Log">
            <div :key="index" v-for="(row, index) in syncLog">
                {{row}}
            </div>
        </b-modal>
    </b-container>
</template>
<script>
    // @ is an alias to /src
    import CategoryApi from "../../../shared/_api/category";
    import DmixApi from "../../../shared/_api/dmix";

    export default {
        name: 'dmix',
        data: function () {
            return {
                customerCategories: [],
                dmixCollections: [],
                busy: false,
                syncLog: []
            }
        },
        methods: {
            sync: function (categoryId) {
                this.busy = true;
                CategoryApi.syncWithDmix(categoryId).then((log) => {
                    this.syncLog = log;
                    this.$bvModal.show('syncLog');
                }).catch((e) => {
                    this.$bvToast.toast(`Error ${e.messages}.`, this.$toastDanger);
                }).finally(() => {
                    this.busy = false;
                });

            },
            update: function (value, category) {
                let collectionMeta = category.articleCollectionMeta ? category.articleCollectionMeta : {
                    id: category.id,
                    dmixUuid: value,
                    collectionType: 'DIAMOND_CATEGORY'
                };
                collectionMeta.dmixUuid = value;
                this.busy = true;
                CategoryApi.updateMeta(collectionMeta).then((res) => {
                    category.articleCollectionMeta = res;
                }).finally(() => {
                    this.busy = false;
                });
            },
        },
        created: function () {
            this.busy = true;
            Promise.all([CategoryApi.getAll(), DmixApi.getCollections()]).then(([customerCategories, dmixCollections]) => {
                this.customerCategories = customerCategories;
                this.dmixCollections = dmixCollections;
            }).finally(() => {
                this.busy = false;
            });
        }
    }
</script>
